export const EMPLOYMENT_VERIFICATION_STATUS_CREATED = 'created';
export const EMPLOYMENT_VERIFICATION_STATUS_FAILED = 'failed';
export const EMPLOYMENT_VERIFICATION_STATUS_COMPLETED = 'completed';

export const EMPLOYMENT_VERIFICATION_STATUS_LIST = [
  EMPLOYMENT_VERIFICATION_STATUS_CREATED,
  EMPLOYMENT_VERIFICATION_STATUS_FAILED,
  EMPLOYMENT_VERIFICATION_STATUS_COMPLETED,
];

export const EMPLOYMENT_VERIFICATION_PROVIDER_PINWHEEL = 'PINWHEEL';

export const EMPLOYMENT_VERIFICATION_STATUS_LIST_NOT_COMPLETED = [
  EMPLOYMENT_VERIFICATION_STATUS_CREATED,
  EMPLOYMENT_VERIFICATION_STATUS_FAILED,
];
